import React from 'react';

export default function CustomReportTable(props) {
    return(
        <>
            <h5 style={{margin:"10px 8px" }}>{props?.title}</h5>
            <div style={{border:".2px solid",margin:"0px 8px",padding:"0px 2px" }}>
            	<div style={{display:"flex",justifyContent:"space-between"}}>
                        {props?.headerTitle?.map(data=>(<div style={{fontSize:"1rem",padding:'.3rem'}}>{data}</div>))}
                </div>
                <div style={{display:"flex"}}>
                <div >
            			{props?.index1?.map(title=>(<div style={{borderRight:".2px solid",borderBottom:".2px solid",fontSize:"1rem",padding:'.3rem',right:0}}>{title}</div>))}
            	</div>
            	{props?.index2?<div>
            			{props?.index2?.map(title=>(<div style={{fontSize:"1rem",padding:'.3rem',wordWrap:"break-word"}}>{title}</div>))}
            	</div>:''}
                <div style={{width:"10%"}}>
                        {props?.index3?.map(title=>(<div style={{borderTop:".2px solid",borderRight:".2px solid",borderBottom:".2px solid",fontSize:"1rem",wordWrap:"break-word",padding:'.3rem'}}>{title}</div>))}
                </div >
                <div style={{width:"23%"}}>
                        {props?.index4?.map(title=>(<div style={{borderTop:".2px solid",borderRight:".2px solid",borderBottom:".2px solid",fontSize:"1rem",wordWrap:"break-word",padding:'.3rem'}}>{title}</div>))}
                </div>
                <div style={{width:"40%"}}>
                        {props?.index5?.map(title=>(<div style={{borderTop:".2px solid",borderRight:".2px solid",borderBottom:".2px solid",fontSize:"1rem",wordWrap:"break-word",padding:'.3rem'}}>{title}</div>))}
                </div>
                <div style={{width:"30%"}}>
                        {props?.index6?.map(title=>(<div style={{borderTop:".2px solid",borderRight:".2px solid",borderBottom:".2px solid",fontSize:"1rem",wordWrap:"break-word",padding:'.3rem'}}>{title}</div>))}
                </div>
            	</div>
            </div>
        </>
    )
}
